import React from 'react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function CTA() {
  return <section className="relative py-32 lg:py-40 bg-brand-navy overflow-hidden" data-id="element-11">
      {/* Background elements */}
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-5 mix-blend-overlay" data-id="element-12" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-amber/20 blur-[150px] rounded-full pointer-events-none" data-id="element-13" />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-14">
        <FadeIn data-id="element-15">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 tracking-tight" data-id="element-16">
            Tu futuro financiero{' '}
            <span className="text-brand-amber" data-id="element-17">empieza hoy.</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-18">
          <p className="text-xl md:text-2xl text-slate-300 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-19">
            Cada día que pasas con mal crédito es dinero que pierdes en
            intereses altos. Toma el control ahora mismo.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-20">
          <div className="flex flex-col items-center gap-6" data-id="element-21">
            <a href="https://calendly.com/jesus-reinosobusinessconsultant/30min" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center gap-3 bg-brand-amber hover:bg-brand-amberHover text-white px-10 py-5 rounded-xl font-bold text-lg md:text-xl transition-all duration-300 shadow-[0_0_40px_-10px_rgba(217,119,6,0.5)] hover:shadow-[0_0_60px_-15px_rgba(217,119,6,0.7)] hover:-translate-y-1 overflow-hidden" data-id="element-22">
              <span className="relative z-10" data-id="element-23">
                RECLAMAR MI EVALUACIÓN ESTRATÉGICA
              </span>
              <ArrowRight size={24} className="relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-24" />
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-25" />
            </a>
            <p className="text-sm text-slate-400 flex items-center gap-2" data-id="element-26">
              <ShieldCheck size={16} className="text-brand-amber" data-id="element-27" />
              Proceso 100% confidencial y seguro
            </p>
            <p className="text-sm text-slate-500 mt-2" data-id="element-28">
              ¿Prefieres escribirnos?{' '}
              <a href="mailto:jesus@reinosobusinessconsultant.com" className="text-brand-amber hover:text-brand-amberHover underline underline-offset-2 transition-colors" data-id="element-29">
                jesus@reinosobusinessconsultant.com
              </a>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}